/*
 * @Author: your name
 * @Date: 2022-01-05 12:34:31
 * @LastEditTime: 2026-06-30 21:09:51
 * @LastEditors: qiuhc 2282747917@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \management-admin\src\menu\index.js
 */
import articleManage from "./articleManage.js";
import position from "./position.js";
import auth from "@/menu/auth";

/**
 * 首页
 * @type {{name: string, path: string, icon: string}}
 */
let home = {
  name: "首页",
  path: "/home",
  permissionsKey: "",
  icon: "fa fa-home"
};

/**
 * 表单组件示例
 * @type {{name: string, path: string, icon: string}}
 */
let fromDemo = {
  name: "表单组件",
  path: "/fromDemo",
  permissionsKey: "",
  icon: "fa fa-file-text"
};

let fileNetworkDisk = {
  name: "云盘",
  path: "/fileNetworkDisk",
  permissionsKey: "",
  icon: "fa fa-cloud"
};
// 图标解析 http://blog.luckly-mjw.cn/tool-show/iconfont-preview/index.html
let menuRouter = [];
if (process.env.NODE_ENV === "development") {
  menuRouter = [
    home,
    fromDemo,
    articleManage,
    ...position,
    fileNetworkDisk,
    auth
  ];
} else {
  //production
  menuRouter = [
    {
      name: "掌柜招招招",
      path: "/company",
      permissionsKey: "",
      icon: "fa fa-group"
    },
    {
      name: "掌柜租房",
      path: "/landlord",
      permissionsKey: "",
      icon: "fa fa-home"
    },
    fileNetworkDisk,
    auth
  ];
}
export default {
  ...menuRouter
  //helpCenter
};
